<template>
  <div ref="container" :style="container">
    <!-- <keep-alive> -->
    <board-item
      v-for="data in itemData"
      :length="itemData.length"
      :key="data.id"
      :name="data.name"
      :app="data.app"
      :params="data.params"
      :data="data.data"
      :size="data.size"
      :row="row"
      :dark="dark"
      :autoplay="autoplay"
      :loop="loop"
      :appinfo="appinfo"
      :qdata="qdata"
      :bid="bid"
      :source="source"
      :menutitle="menutitle"
    ></board-item>
  <!-- </keep-alive> -->
  </div>
</template>

<script>
import BoardItem from './BoardItem.vue';

export default {
  name: 'board-layout',
  components: {
    BoardItem,
  },
  props: ['value','dark','autoplay','loop', 'appinfo', 'qdata', 'bid', 'source', 'menutitle'],
  data() {
    return {
      container: {
        display: 'grid',
        position: 'absolute',
        height: '100%',
        width: '100%',
        'min-width': '98%',
        'min-height': '96%',
        "grid-column-gap": "1%",
        "grid-row-gap": "2%",

      },
      itemData: [],
      row: 2
    };
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        const { layout, grid } = this.value;
        this.dealLayout(layout);
        this.dealGrid(grid);
      },
    },
  },
  methods: {
    dealLayout(layout) {
      const { col, row } = layout;
      this.row = row;
      this.container['grid-template-columns'] = `${'auto '.repeat(col)}`;
      this.container['grid-template-rows'] = `${'auto '.repeat(row)}`;
    },

    dealGrid(grid) {
      const itemData = grid.map((item, id) => {
        var {
          name, app, params, data, ...size
        } = item;
        app = app || "app_" + id;
        name = name || "grid_" + id;
        params = params || {};
        data = data || {};
        return {
          name,
          app,
          params,
          data,
          size,
          id,
        };
      });

      this.itemData = itemData;
    },
  },
};
</script>
